import {IconButton, Tooltip} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import {KeyboardBackspaceOutlined} from "@mui/icons-material";
import logo from "../../assets/logobeta.png";
import Dropdown from "../../components/Dropdown/Dropdown";
import ShowContentForUser from "../../components/modalwindow/ShowContentForUser";
import FeedbackIcon from '@mui/icons-material/Feedback';
import {useState} from 'react';

const modalContent =  (
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSfJaKLtgLbEnsqvO8JNtxeR7sRi6Yhr2f9GusenrzG0N3DWiQ/viewform?embedded=true"
      width="640"
      height="562"
      
      title="myIframeExample"
      style={{ border: 'none' }}
    >
      Cargando…
    </iframe>
    
    

  );

export default function HeaderComponent({isSidebarOpen, setSidebarOpen}) {
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <nav className="header-nav-main">
            <IconButton
                onClick={() => setSidebarOpen(!isSidebarOpen)}
                sx={{ml: 1, color: 'black'}}>
                {
                    isSidebarOpen
                        ? <KeyboardBackspaceOutlined/>
                        : <MenuIcon/>
                }
            </IconButton>
            <img className={"header-nav-img-logo"} src={logo}/>
            <div className={"header-nav-container-buttons"}>
                <Tooltip
                    title="Por favor, ayudanos a mejorar: Envianos errores, sugerencias y comentarios sobre la biblioteca privada">
                    <button className="open-modal-button" style={{
                        cursor: 'pointer',
                        marginTop: '4px',
                        marginRight: '85px',
                        backgroundColor: '#8b3dff',
                        border: 'none',
                        borderRadius: '20px',
                        width: '40px',
                        height: '40px'
                    }} onClick={handleOpenModal}>
                        <FeedbackIcon sx={{margin: 'auto', color: 'white'}}/>
                    </button>

                </Tooltip>
                {showModal && <ShowContentForUser onClose={handleCloseModal} myIframe={modalContent} width={700} height={600} />}
                <div style={{marginTop: '5px', marginRight: '10px'}}>
                    <Dropdown/>
                </div>
            </div>
        </nav>
    );
}